<script setup>
import { computed, ref } from 'vue';
import { useSupportPlanStore } from '@/stores/supportPlan';
import { storeToRefs } from 'pinia';

import ClientSupportPlanDetailsTab from '../../components/Client/ClientSupportPlanDetailsTab.vue';
import ClientGoalTab from '../../components/Client/ClientGoalTab.vue';
// import DocumentManager from '@/components/Documents/DocumentManager.vue';
import ClientCriteriaTab from '../../components/Client/ClientCriteriaTab.vue';
import ClientSupportPlanEventTab from '../../components/Client/ClientSupportPlanEventTab.vue';

const { active } = storeToRefs(useSupportPlanStore());
const tab = ref('support_plan_event');

const pathParts = computed(() => {
    const segments = window.location.pathname.split('/');
    const clientId = segments[2];
    const planId = segments[4];

    return {
        paths: {
            client: `/clients/${clientId}`,
            supportPlan: `/clients/${clientId}/support-plan/${planId}`,
        }
    };
});
</script>

<template>
<MainContentLayout>

    <template #breadcrumb>
        <v-breadcrumbs class="flex gap-4">
            <v-breadcrumbs-item :href="pathParts.paths.client">
                {{ $t('label.client') }}
            </v-breadcrumbs-item>
            <v-icon>mdi-chevron-right</v-icon>
            <v-breadcrumbs-item disabled :href="pathParts.paths.supportPlan">
                {{ $t('label.support_plan') }}
            </v-breadcrumbs-item>
        </v-breadcrumbs>
    </template>
    <template #title>{{ $t('title.support_plan_management', { name: `${active.client?.first_name} ${active.client?.last_name}` ?? '', plan_type: `${active.type?.name}` ?? '' }) }}</template>
    <template #actions />
    <div> 
        <v-card>
            <v-tabs v-model="tab">
                <v-tab value="support_plan_event">{{ $t('label.events') }}</v-tab>
                <v-tab value="goal_management">{{ $t('label.goal_tracking') }}</v-tab>
                <!-- <v-tab value="documents">{{ $t('label.documents') }}</v-tab> -->
                <v-tab value="criteria">{{ $t('label.criteria') }}</v-tab>
                <v-tab value="support_plan_details">{{ $t('label.details') }}</v-tab>
            </v-tabs>
            <v-card-text>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="support_plan_details" class="p-4">
                        <ClientSupportPlanDetailsTab :support-plan="active" />
                    </v-tabs-window-item>
                    <v-tabs-window-item value="goal_management" class="p-4">
                        <ClientGoalTab :support-plan="active" />
                    </v-tabs-window-item>
                    <!-- <v-tabs-window-item value="documents" class="p-4">
                        <DocumentManager :documentable="active" type="support-plan" />
                    </v-tabs-window-item> -->
                    <v-tabs-window-item value="criteria" class="p-4">
                        <ClientCriteriaTab :support-plan="active" />
                    </v-tabs-window-item>
                    <v-tabs-window-item value="support_plan_event" class="p-4">
                        <ClientSupportPlanEventTab :support-plan="active" />
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>
        </v-card>
    </div>
</MainContentLayout>
</template>
